module.exports = __webpack_public_path__ + "76b178293f88c4730cfed6b2a42e84a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/hydrob&a.png
// module id = 120
// module chunks = 1